import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsScorecardBonusComponent } from './scorecard-bonus.component';

@NgModule({
    declarations: [CmpsScorecardBonusComponent],
    imports: [CmpsIconModule, CommonModule],
    exports: [CmpsScorecardBonusComponent],
})
export class CmpsScorecardBonusModule {}
